import FixtureGetSubscriptionsByIdActive from "./get-subscriptions-by-id--active";
import FixtureGetSubscriptionsByIdInactiveCancelled from "./get-subscriptions-by-id--inactive-cancelled";
import FixtureGetSubscriptionsByIdInactivePayment from "./get-subscriptions-by-id--inactive-payment";
import FixtureGetSubscriptionsByIdPaused from "./get-subscriptions-by-id--paused";
import FixtureGetSubscriptionsByIdPending from "./get-subscriptions-by-id--pending";
import FixtureGetSubscriptionsByIdCancelling from "./get-subscriptions-by-id--cancelling";
import FixtureGetSubscriptionsByIdActiveTrial from "./get-subscriptions-by-id--active-trial";
import FixtureGetSubscriptionsByIdActivePrepaid from "./get-subscriptions-by-id--active-prepaid";

const FixtureAPIGetUserSubscriptions = {
  success: {},
  payload: {
    subscriptions: [
      FixtureGetSubscriptionsByIdActive.payload.subscription,
      FixtureGetSubscriptionsByIdActiveTrial.payload.subscription,
      FixtureGetSubscriptionsByIdActivePrepaid.payload.subscription,
      FixtureGetSubscriptionsByIdInactiveCancelled.payload.subscription,
      FixtureGetSubscriptionsByIdInactivePayment.payload.subscription,
      FixtureGetSubscriptionsByIdPaused.payload.subscription,
      FixtureGetSubscriptionsByIdPending.payload.subscription,
      FixtureGetSubscriptionsByIdCancelling.payload.subscription,
    ],
  },
};
export default FixtureAPIGetUserSubscriptions;
